import React from "react";

/**
 * A thin dahlia-pattern band used as a section divider.
 * Sits between sections and ties the whole site together.
 *
 *  - variant: "thin" (h-16/20) or "tall" (h-32/40)
 *  - tint: how heavy the cream wash is (0-1, default 0.55)
 *  - pattern: number 1-4 or full path
 */
const PATTERNS = {
  1: "/photos/patterns/dahlia-pattern-1.jpg",
  2: "/photos/patterns/dahlia-pattern-2.jpg",
  3: "/photos/patterns/dahlia-pattern-3.jpg",
  4: "/photos/patterns/dahlia-pattern-4.jpg",
  rich: "/photos/patterns/dahlia-rich.jpg",
};

export default function PatternBand({
  pattern = 2,
  variant = "thin",
  tint = 0.4,
  className = "",
  testid,
}) {
  const src = typeof pattern === "string" ? pattern : PATTERNS[pattern] || PATTERNS[2];
  const h =
    variant === "tall"
      ? "h-32 md:h-44"
      : variant === "mid"
      ? "h-24 md:h-32"
      : "h-16 md:h-20";

  return (
    <div
      data-testid={testid}
      aria-hidden="true"
      className={`relative overflow-hidden ${h} ${className}`}
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${src})` }}
      />
      <div
        className="absolute inset-0"
        style={{
          background: `linear-gradient(180deg, rgba(250,244,230,${tint}) 0%, rgba(250,244,230,${
            Math.min(1, tint + 0.15).toFixed(2)
          }) 100%)`,
        }}
      />
    </div>
  );
}
